import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificationsAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { notificationTarget } from '../utils/notificationTarget';
import { fmtDate } from '../utils/dateUtils';

const TYPE_ICONS = {
  task_assigned: '📌',
  task_delay: '⏰',
  early_completion: '🎉',
  issue_update: '⚠',
  concern_response: '✉',
  task_reviewed: '✅',
  general: '🔔',
};

export default function Notifications() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => notificationsAPI.list().then(({ data }) => setNotifs(data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await notificationsAPI.markRead(id);
    setNotifs((prev) => prev.map((n) => n.id === id ? { ...n, is_read: true } : n));
  };

  const handleClick = (n) => {
    if (!n.is_read) markRead(n.id);
    const target = notificationTarget(n, user?.role);
    if (target) navigate(target);
  };

  const markAll = async () => {
    await notificationsAPI.markAllRead();
    setNotifs((prev) => prev.map((n) => ({ ...n, is_read: true })));
  };

  const unread = notifs.filter((n) => !n.is_read).length;

  return (
    <div className="page">
      <div className="page-header">
        <h2>Notifications {unread > 0 && <span className="notif-badge-large">{unread}</span>}</h2>
        {unread > 0 && (
          <button className="btn btn-ghost" onClick={markAll}>Mark all as read</button>
        )}
      </div>

      {loading ? (
        <div className="page-loading">Loading...</div>
      ) : notifs.length === 0 ? (
        <div className="empty-state">No notifications yet.</div>
      ) : (
        <div className="notif-list">
          {notifs.map((n) => (
            <div
              key={n.id}
              className={`notif-item${n.is_read ? ' read' : ' unread'}`}
              style={{ cursor: 'pointer' }}
              onClick={() => handleClick(n)}
            >
              <div className="notif-icon">{TYPE_ICONS[n.type] || '🔔'}</div>
              <div className="notif-body">
                <div className="notif-title">{n.title}</div>
                <div className="notif-message">{n.message}</div>
                <div className="notif-time">{fmtDate(n.created_at)}</div>
              </div>
              {!n.is_read && <div className="unread-dot" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
